import { SeoMeta } from "@/utils/seo/SeoMeta";
import * as P from "@components/customizing/print/Print.styles";
import * as Faq from "@components/csboard/faq/faq-styles";
import { usePrintFaqQuery } from "@hook/customizing/print/usePrintFaqQuery";
import Layout from "@components/layout/Layout";
import { useState } from "react";
import { PrintDesignService } from "@components/customizing/print/PrintDesignService";
import { PrintTab } from "@components/customizing/print/printTab/PrintTab";
import { useRouter } from "next/router";

const PrictFAQPage = () => {
  const router = useRouter();
  const { data: faqList, isLoading, error } = usePrintFaqQuery(router.isReady); //faq 리스트
  const [isActive, setIsActive] = useState(""); //faq

  const onClickOpenFAQ = (i) => () => {
    if (isActive !== i) setIsActive(i);
    if (isActive === i) setIsActive("");
  };
  return (
    <Layout
      parent={"홈"}
      sub={"소량인쇄"}
      subTitle={"소량인쇄 FAQ"}
      pageTitle={SeoMeta.smallPrintServiceFAQ.title}
      pageDesc={SeoMeta.smallPrintServiceFAQ.description}
      pageKeyword={SeoMeta.smallPrintServiceFAQ.keywords}
    >
      <PrintTab />
      {Array.isArray(faqList) && faqList.length > 0 && (
        <div className={"container mb-50"}>
          <P.NormalTitle>
            소량인쇄 <strong>FAQ</strong>
          </P.NormalTitle>
          <Faq.TableWrapper>
            {faqList.map((el, i) => (
              <Faq.TableRow key={i} onClick={onClickOpenFAQ(i)}>
                <Faq.FAQTop isActive={isActive === i}>
                  <Faq.FAQTitle>
                    {el.category}
                    {el.title}
                  </Faq.FAQTitle>
                  <i
                    className={
                      isActive === i
                        ? "fi-rs-angle-small-up"
                        : "fi-rs-angle-small-down"
                    }
                  />
                </Faq.FAQTop>
                <Faq.FAQContent
                  isActive={isActive === i}
                  dangerouslySetInnerHTML={{ __html: el.contents }}
                ></Faq.FAQContent>
              </Faq.TableRow>
            ))}
          </Faq.TableWrapper>
        </div>
      )}
      <PrintDesignService />
    </Layout>
  );
};
export default PrictFAQPage;
